export default __webpack_public_path__ + "static/media/Hajar_El_Haddaoui_AHV_In_Moms_We_Trust.b3b69ab8.jpg";